import React from "react";
import {Route, Routes} from "react-router-dom";
import "./App.scss";
import Main from "./containers/Main";
import PrivatePage from "./containers/privateSpace/PrivatePage";
import {StyleProvider} from "./contexts/StyleContext";
import {useLocalStorage} from "./hooks/useLocalStorage";

function App() {
  // Theme state lives here so both the portfolio and the private page share it.
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/private" element={<PrivatePage />} />
          {/* Anything unrecognised falls back to the portfolio. */}
          <Route path="*" element={<Main />} />
        </Routes>
      </StyleProvider>
    </div>
  );
}

export default App;
